window.onload = function () {
    $('div[data-container=parallax]').each(function () {
        const elm = this
        const parallax = $(this).parallaxize({speed: 0.2})
        setTimeout(function () {
            const image = parallax.$image
            if (image[0]) {
                image[0].setAttribute('aria-hidden', 'true')
                image[0].setAttribute('alt', elm.getAttribute('data-parallax-alt'))
            }
        }, 100)
    })
}
